import { useCallback } from 'react';
import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { TableStateManager } from '@common/components/table/types';

export function useControlledSorting({
  resetPagination,
  initialState,
  tableStateManager,
}: {
  resetPagination: () => void;
  initialState: SortingState;
  tableStateManager: TableStateManager;
}) {
  const [sortingState, setSortingState] =
    tableStateManager.useSortingState(initialState);

  const onSortingChange: OnChangeFn<SortingState> = useCallback(
    (stateUpdater) => {
      setSortingState(stateUpdater);
      resetPagination();
    },
    [setSortingState],
  );

  return { sortingState, onSortingChange };
}
